module.exports = __webpack_public_path__ + "img/9791188299126.fbb0f1ef.jpg";